import store from '@/store'

export function getFilteredHistory (briefing) {
  const fieldList = [...arguments].slice(1)
  return briefing.flightHistory.filter(item => fieldList.includes(item.field)) || []
}

export function checkChanges (briefing, string) {
  const timeFrame = briefing.std.slice(0, 7)
  const existingHistory = store.getters.historyByTimeFrame(timeFrame)
  const idLastUpdates = briefing[string][0]?.id
  return idLastUpdates ? !existingHistory?.includes(idLastUpdates) : false
}
